/**
 * Spacing utils for inset and offset
 */
var spacingUtils = {
  offset: function offset(token) {
    return {
      margin: token
    };
  },
  offsetY: function offsetY(token) {
    return {
      marginTop: token,
      marginBottom: token
    };
  },
  offsetX: function offsetX(token) {
    return {
      marginLeft: token,
      marginRight: token
    };
  },
  offsetTop: function offsetTop(token) {
    return {
      marginTop: token
    };
  },
  offsetBottom: function offsetBottom(token) {
    return {
      marginBottom: token
    };
  },
  offsetLeft: function offsetLeft(token) {
    return {
      marginLeft: token
    };
  },
  offsetRight: function offsetRight(token) {
    return {
      marginRight: token
    };
  },
  inset: function inset(token) {
    return {
      padding: token
    };
  },
  insetY: function insetY(token) {
    return {
      paddingTop: token,
      paddingBottom: token
    };
  },
  insetX: function insetX(token) {
    return {
      paddingLeft: token,
      paddingRight: token
    };
  },
  insetTop: function insetTop(token) {
    return {
      paddingTop: token
    };
  },
  insetBottom: function insetBottom(token) {
    return {
      paddingBottom: token
    };
  },
  insetLeft: function insetLeft(token) {
    return {
      paddingLeft: token
    };
  },
  insetRight: function insetRight(token) {
    return {
      paddingRight: token
    };
  }
};
export { spacingUtils };